// Replaced by useOfferPR and useOfferGCPR
import { API_RESOURCE } from '@/constants/api.constant'
import OfferSourcingService from '@/features/offers/services/offerSourcing.service'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'

const useOfferSourcing = () => {
  const service = new OfferSourcingService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useSplitCostBudget = useAction({
    mutationFn: service.splitCostBudget,
    queryKey: queryKey,
    message: 'Successfully Split Cost Budget',
  })

  return {
    useSplitCostBudget,
  }
}

export default useOfferSourcing
